import { quoteMapActions } from "@/store/modules/quote";
import Vue from "vue";

export default Vue.extend({
  methods: {
    ...quoteMapActions(["rateQuote"]),
    async doRateQuote(quoteId: string) {
      await this.rateQuote({ quoteId });
    }
  }
});
